import script from "./CienciaTecnologia.vue?vue&type=script&setup=true&lang=js"
export * from "./CienciaTecnologia.vue?vue&type=script&setup=true&lang=js"

import "./CienciaTecnologia.vue?vue&type=style&index=0&id=272dc9ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-272dc9ca"]])

export default __exports__